import { isValidEmail } from "../../../utils/checkemail";
import { isValidCPF } from "../../../utils/cpf";
import { isValidRandomPixKey } from "../../../utils/isvalidrandompix";
import { justNumbers } from "../../../utils/justnumbers";
import { formatPhone } from "../../../utils/phone";

export function formatPix(pixType:string,value:string){
    if(pixType=='TELEFONE'){
        return formatPhone(justNumbers(value));
    }else if(pixType=='EMAIL'){
        return value.toLowerCase().trim();
    }else if(pixType=='ALEATORIA'){
        return value.trim();
    }
    return value;
}
export function checkPix(pixType:string,value:string){
  if(pixType=='CPF'){
       return isValidCPF(value);
  }
  if(pixType=='TELEFONE'){
        return justNumbers(value).length==11;
    }else if(pixType=='EMAIL'){
        return isValidEmail(value);
    }else if(pixType=='ALEATORIA'){
        return isValidRandomPixKey(value)
    }
    return false;
}
export function normalizePix(pixType:string,value:string){
  if(pixType=='CPF'||!value)return justNumbers(value);
  if(pixType=='TELEFONE'){
        return justNumbers(value);
    }else if(pixType=='EMAIL'){
        return value.toLowerCase().trim();
    }else if(pixType=='ALEATORIA'){
        return value.trim();
    }
}

export function pixToPixType(pix:string){
  if(pix=='TELEFONE')return 'phone';
  if(pix=='CPF')return 'cpf';
  if(pix=='EMAIL')return 'email';
  return 'random';
}